import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getUserLogin } from '../services/auth'

export const getAuthUserLogin = createAsyncThunk('user/getAuthUserLogin', async () => {
  const params = {
    include: 'images'
  }
  const response = await getUserLogin(params)
  return response
})

const userLogin = createSlice({
  name: 'user_login',
  initialState: {
    isLoadingUser: true,
    data: null
  },
  reducers: {
    userLoginState: (state, action) => {
      state.isLoadingUser = action.payload.isLoadingUser
      state.data = action.payload
    }
  },
  extraReducers: {
    [getAuthUserLogin.pending]: (state) => {
      state.isLoadingUser = true
    },
    [getAuthUserLogin.fulfilled]: (state, action) => {
      state.isLoadingUser = false
      state.data = setDetailUser(action.payload)
    },
    [getAuthUserLogin.rejected]: (state) => {
      state.isLoadingUser = false
      state.data = null
    }
  }
})

const handleDataIncluded = (data, key, id) => {
  return data[key][id].attributes
}

const setDetailUser = (payload) => {
  const attributes = payload.data
  const relationships = payload.data.relationships
  const included = payload.included

  const getImageUser = relationships.images.length === 0 ? null : handleDataIncluded(included, 'images', relationships.images[0].id).source

  const remapData = {
    ...attributes,
  }
  remapData.attributes.images = getImageUser

  return remapData
}

export const { userLoginState } = userLogin.actions
export default userLogin.reducer